import { render, staticRenderFns } from "./updateInfo.vue?vue&type=template&id=2f07d49a&scoped=true"
import script from "./updateInfo.vue?vue&type=script&lang=js"
export * from "./updateInfo.vue?vue&type=script&lang=js"
import style0 from "./updateInfo.vue?vue&type=style&index=0&id=2f07d49a&prod&scoped=true&lang=css"
import style1 from "./updateInfo.vue?vue&type=style&index=1&id=2f07d49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07d49a",
  null
  
)

export default component.exports